export const getAddress = (country: string, state: string, city: string) => {
  
  if (state) return [city, state, country].join(', ')
  return 'Remoto'
  };